/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports

import React, { useState, useEffect } from "react";
import {
    Box,
    SimpleGrid,
    FormControl,
    FormLabel,
    Input,
    Button,
   
    Flex,
    useToast,
} from "@chakra-ui/react";
import { constants } from "constants/constants";
import axios from "axios";
import Select from 'react-select';


export default function AddSupportMember() {
    const [generatedPassword, setGeneratedPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState({});
    const [roles, setRoles] = useState([]);

    const [warehouseData, setWarehouseData] = useState([]);
    const [warehouse, setWarehouse] = useState([]);
    const toast = useToast();

    useEffect(() => {
      const fetchRoles = async () => {
        try {
          const response = await axios.get(`${constants.apiUrl}/roles-permissions`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          });
  
          if (response.status === 200) {
            const { roles } = response.data;
            setRoles(roles);

          } else {
            throw new Error("Failed to fetch roles");
          }
        } catch (error) {
          console.error("Error fetching roles:", error);
          // Handle error (e.g., show error toast)
          toast({
            position: "bottom-right",
            title: "Error fetching roles",
            description: error.message,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      };
  
      fetchRoles();
    }, []);
    const handleRegister = () => {

    if (!firstName || !lastName || !email || !generatedPassword || !role) {
      // Display a toast or any other error handling
      toast({
        position: "bottom-right",
        title: "Please fill all required fields.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return; // Stop the registration process
    }


      const userData = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        password: generatedPassword,
        role: role.value,
        mintsoftClientCode: null,
        warehouse: warehouse.join(',')
      };
  
      axios
        .post(`${constants.apiUrl}/register`, userData) // Make a POST request using Axios
        .then((response) => {
          
          if (response.status === 200) {
            // Registration successful
            console.log("Registration successful");
            toast({
              position: 'bottom-right',
              title: 'Account created.',
              description: "We've created your account for you.",
              status: "success",
              duration: 3000, // Duration in milliseconds
              isClosable: true, // Whether the toast can be closed by the user
            });

              // Reset form fields
              setFirstName("");
              setLastName("");
              setEmail("");
              setGeneratedPassword("");
              setRole("");
              setWarehouse([]);
            
          } 
        })
        .catch((error) => {
          console.error("Error creating user :", error);
          if(error.response.status == 409){
            toast({
              position: 'bottom-right',
              title: "User with the same email already exists",
              status: "info",
              duration: 3000, // Duration in milliseconds
              isClosable: true, // Whether the toast can be closed by the user
            });
            
          }else{
            toast({
              position: 'bottom-right',
              title: "Error creating user" + error,
              status: "error",
              duration: 3000, // Duration in milliseconds
              isClosable: true, // Whether the toast can be closed by the user
            });
          }
     
        });

    };

    const handleRoleChange = (selectedOptions) => {
      setRole(selectedOptions || []);
  };
      const handleWarehouseChange = (selectedOptions) => {
        const selectedWarehouses = selectedOptions.map(option => option.value);
        setWarehouse(selectedWarehouses); // Update the 'warehouse' state
    };
    
      
    const generateRandomPassword = () => {
        const randomPassword = Math.random().toString(36).substring(2, 10);
        setGeneratedPassword(randomPassword);
    };

    return (
        <Box
            pt={{ base: "130px", md: "80px", xl: "80px" }}
            backgroundColor="white"
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
        >
            <SimpleGrid columns={1} gap="20px" mb="20px" w="50%">
                {/* First Name */}
                <FormControl>
                    <FormLabel>First Name</FormLabel>
                    <Input placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
                </FormControl>

                {/* Last Name */}
                <FormControl>
                    <FormLabel>Last Name</FormLabel>
                    <Input placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} required/>
                </FormControl>

                {/* Email */}
                <FormControl>
                    <FormLabel>Email</FormLabel>
                    <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </FormControl>

                {/* Password */}
                <FormControl>
                    <FormLabel>Password</FormLabel>
                    <Flex align="center">
                        <Input
                            type="text"
                            value={generatedPassword}
                            onChange={(e) => setGeneratedPassword(e.target.value)}
                            required
                            width="50%"
                        />
                        <Button
                            colorScheme="green"
                            variant="brand"
                            onClick={generateRandomPassword}
                            ml="2"
                        >
                            Generate Password
                        </Button>
                    </Flex>
                </FormControl>

                {/* Role */}
                <FormControl>
                    <FormLabel>Role</FormLabel>
                    <Select
                  
                        placeholder="Select Role"
                        value={role}
                        onChange={handleRoleChange}
                        options={roles}
                    />
                    </FormControl>
                   
                {/* Submit Button */}
                <Button variant="brand" size="md" onClick={handleRegister}>Add Support Member</Button>
            </SimpleGrid>
        </Box>
    );
}


